import template from './login.html';
import controller from './login.controller';
import './login.scss';

let loginComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: "vm"
};

export default loginComponent;



// WEBPACK FOOTER //
// ./client/app/components/login/login.component.js